import { useState, useEffect } from 'react';
import { message,Avatar } from 'antd';
import { UserOutlined } from '@ant-design/icons';
import { StaffSearchComponent } from '../components/StaffSearchComponent';
import { API_BASE_URL } from '../config';

export const useStaffSearch = ({  apiBaseUrl }) => {
  // 员工搜索相关状态
  const [searchQuery, setSearchQuery] = useState(''); // 搜索框的值
  const [searchingUsers, setSearchingUsers] = useState(false);
  const [searchResults, setSearchResults] = useState([]); // 员工的详细信息
  const [selectedUsers, setSelectedUsers] = useState([]); // 选择的员工
  const [selectedUsersZhuye, setSelectedUsersZhuye] = useState(); // 选择的员工主页
  const [dropdownOpen, setDropdownOpen] = useState(false);

  // 生成下拉菜单属性
  const menuProps = {
    items: searchResults.map(user => ({
      key: user.userId,
      label: (
        <div style={{ display: 'flex', alignItems: 'center', gap: '8px' }}>
          <Avatar 
            size="small" 
            src={user.avatar} 
            icon={<UserOutlined />}
          />
          <div>
            <div style={{ fontWeight: 'bold' }}>{user.name}</div>
            <div style={{ fontSize: '12px', color: '#666' }}>
              {user.title} {user.dept && `| ${user.dept}`}
            </div>
          </div>
        </div>
      ),
      onClick: () => handleSelectUserWithClose(user)
    })),
  };
  const menuPropszhuye = {
    items: searchResults.map(user => ({
      key: user.userId,
      label: (
        <div style={{ display: 'flex', alignItems: 'center', gap: '8px' }}>
          <Avatar 
            size="small" 
            src={user.avatar} 
            icon={<UserOutlined />}
          />
          <div>
            <div style={{ fontWeight: 'bold' }}>{user.name}</div>
            <div style={{ fontSize: '12px', color: '#666' }}>
              {user.title} {user.dept && `| ${user.dept}`}
            </div>
          </div>
        </div>
      ),
      onClick: () => handleSelectUserWithClosezhuye(user)
    })),
  };

  // 使用StaffSearchComponent
  const staffSearch = StaffSearchComponent({
    apiBaseUrl,
    onUserDetailsFetched: (userDetails) => {
      console.log('用户详细信息获取完成:', userDetails);
    },
    onError: (error) => {
      console.error('用户搜索错误:', error);
    }
  });

  useEffect(() => {
    // 当searchResults有数据时自动打开下拉菜单
    if (searchResults.length > 0) {
      setDropdownOpen(true);
    } else {
      setDropdownOpen(false);
    }
  }, [searchResults]);

  // 处理输入框点击事件
  const handleInputClick = () => {
    if (searchResults.length > 0) {
      setDropdownOpen(true);
    }
  };

  // 处理下拉菜单关闭事件
  const handleDropdownVisibleChange = (open) => {
    if (!open) {
      setDropdownOpen(false);
    }
  };

  const handleSelectUserWithClosezhuye = (user) => {
      handleSelectUserZhuye(user);
    setDropdownOpen(false); // 选择用户后关闭下拉菜单
  };
  // 处理用户选择事件
  const handleSelectUserWithClose = (user) => {
      handleSelectUser(user);
    setDropdownOpen(false); // 选择用户后关闭下拉菜单
  };

  // 搜索钉钉用户
  const handleSearchUsers = async () => {
    try {
      const userDetails = await staffSearch.searchUsers(searchQuery, {
        offset: 0,
        size: 10
      });
      setSearchResults(userDetails);
    } catch (error) {
      console.error('搜索用户错误:', error);
      message.error('搜索失败，请稍后重试');
    }
  };

  const handleSelectUserZhuye = async (user) => {
    console.log('选择用户2:', user);
      const response = await fetch(`${API_BASE_URL}/dingding_user/update`, {
                  method: 'POST',
                  headers: {
                    'Content-Type': 'application/json',
                  },
                  body: JSON.stringify({
                    du_userid: user.userId,
                    du_name: user.name,
                    du_avatar: user.avatar,
                  })
                });
    setSelectedUsersZhuye(user);
  };

  // 选择用户
  const handleSelectUser = async (user) => {
    console.log('选择用户:', user);
      const response = await fetch(`${API_BASE_URL}/dingding_user/update`, {
                  method: 'POST',
                  headers: {
                    'Content-Type': 'application/json',
                  },
                  body: JSON.stringify({
                    du_userid: user.userId,
                    du_name: user.name,
                    du_avatar: user.avatar,
                  })
                });
    if (!selectedUsers.find(u => u.userId === user.userId)) {
      setSelectedUsers(prev => [...prev, {
        ...user,
        key: Date.now() + Math.random()
      }]);
      // message.success(`已选择用户: ${user.name}`);
    } else {
      message.warning('该用户已选择');
    }
  };

  // 移除已选择的用户
  const handleRemoveUser = (userKey) => {
    setSelectedUsers(prev => prev.filter(user => user.key !== userKey));
  };

  // 重置搜索状态
  const resetSearchState = () => {
    setSelectedUsers([]);
    setSearchResults([]);
    setSearchQuery('');
    setDropdownOpen(false);
  };

  return {
    // 状态
    menuProps,
    menuPropszhuye,
    searchQuery,
    searchingUsers,
    searchResults,
    selectedUsers,
    dropdownOpen,
    selectedUsersZhuye,
    
    // 方法
    setSelectedUsersZhuye,
    setSearchQuery,
    setSearchingUsers,
    setSearchResults,
    setSelectedUsers,
    setDropdownOpen,
    handleInputClick,
    handleDropdownVisibleChange,
    handleSelectUserWithClose,
    handleSearchUsers,
    handleSelectUser,
    handleRemoveUser,
    resetSearchState
  };
};